export { getServerSideURL, getClientSideURL } from '@onclicks/sharedutils/getURL'
